import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { greetingandwishesdata } from '../data/greetingandwishesdata';

const placeholderImg = '/defaultimages/imagenotavailable.jpg';

const getSocialLinks = (item) => {
  const links = [
    { key: 'sm_insta', label: 'Instagram' },
    { key: 'sm_facebook', label: 'Facebook' },
    { key: 'sm_whatsapp', label: 'WhatsApp' },
    { key: 'sm_youtube', label: 'YouTube' },
  ];

  return links
    .map(({ key, label }) => ({
      label,
      url: typeof item?.[key] === 'string' ? item[key].trim() : '',
    }))
    .filter((link) => Boolean(link.url));
};

const GreetingAndWishes = () => {
  const [searchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [modalCard, setModalCard] = useState(null);
  const highlightId = searchParams.get('highlight');

  useEffect(() => {
    // If a highlight ID is provided, open its modal
    if (highlightId) {
      const card = greetingandwishesdata.find(item => item.gid === parseInt(highlightId));
      if (card) {
        setModalCard(card);
      }
    }
  }, [highlightId]);

  // Get unique categories
  const categories = ['all', ...new Set(greetingandwishesdata.map(item => item.category))];

  // Filter cards based on selected category
  const filteredCards = selectedCategory === 'all'
    ? greetingandwishesdata
    : greetingandwishesdata.filter(item => item.category === selectedCategory);

  // Sort by listing order
  const sortedCards = [...filteredCards].sort((a, b) => a.listingorder - b.listingorder);

  const openModal = (card) => {
    setModalCard(card);
  };

  const closeModal = () => {
    setModalCard(null);
  };

  const socialLinks = modalCard ? getSocialLinks(modalCard) : [];

  return (
    <div style={{ padding: '1.5rem', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '2rem', color: '#333', marginBottom: '1rem', textAlign: 'center' }}>
        Greetings & Wishes
      </h1>
      <p style={{ fontSize: '1rem', color: '#666', textAlign: 'center', marginBottom: '2rem' }}>
        Share special moments and celebrate with our community
      </p>

      {/* Category Filter */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            style={{
              padding: '0.6rem 1.2rem',
              border: selectedCategory === cat ? '2px solid #1976d2' : '1px solid #ccc',
              background: selectedCategory === cat ? '#e3f2fd' : '#fff',
              color: selectedCategory === cat ? '#1976d2' : '#333',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '0.95rem',
              fontWeight: selectedCategory === cat ? '600' : '400',
              textTransform: 'capitalize',
              transition: 'all 0.3s ease'
            }}
          >
            {cat.replace(/([A-Z])/g, ' $1').trim() || 'All'}
          </button>
        ))}
      </div>

      {/* Cards Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
        {sortedCards.length > 0 ? (
          sortedCards.map(card => (
            <div
              key={card.gid}
              onClick={() => openModal(card)}
              style={{
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                background: '#fff'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              {/* Image */}
              <div style={{ height: '220px', overflow: 'hidden', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img
                  src={card.imageUrl || card.imagepath || placeholderImg}
                  alt={card.title}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  onError={e => { e.target.src = placeholderImg; }}
                />
              </div>

              {/* Content */}
              <div style={{ padding: '1rem' }}>
                <span style={{ display: 'inline-block', padding: '0.3rem 0.8rem', background: '#e3f2fd', color: '#1976d2', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600', marginBottom: '0.5rem', textTransform: 'capitalize' }}>
                  {card.category}
                </span>
                <h3 style={{ margin: '0.5rem 0', fontSize: '1.1rem', color: '#333', fontWeight: '600' }}>
                  {card.title}
                </h3>
                <p style={{ margin: '0.5rem 0', fontSize: '0.9rem', color: '#666' }}>
                  {card.nameoftheperson}
                </p>
                <p style={{ margin: '0.5rem 0', fontSize: '0.85rem', color: '#888', fontStyle: 'italic' }}>
                  From: {card.nameofthewisher}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#999', padding: '2rem' }}>
            No wishes found for this category.
          </p>
        )}
      </div>

      {/* Modal */}
      {modalCard && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '1rem'
          }}
          onClick={closeModal}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: '#f5f5f5',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                color: '#333',
                zIndex: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ✕
            </button>

            {/* Modal Content */}
            <div style={{ padding: '1.5rem' }}>
              {/* Image Carousel */}
              {modalCard.photos && modalCard.photos.length > 0 && (
                <div style={{ marginBottom: '1.5rem', borderRadius: '8px', overflow: 'hidden', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img
                    src={modalCard.photos[0]}
                    alt={modalCard.title}
                    style={{ width: '100%', maxHeight: '500px', objectFit: 'contain' }}
                    onError={e => { e.target.src = placeholderImg; }}
                  />
                </div>
              )}

              {/* Title */}
              <h2 style={{ fontSize: '1.5rem', color: '#333', marginBottom: '0.5rem' }}>
                {modalCard.title}
              </h2>

              {/* Category Badge */}
              <span style={{ display: 'inline-block', padding: '0.4rem 0.9rem', background: '#e3f2fd', color: '#1976d2', borderRadius: '12px', fontSize: '0.8rem', fontWeight: '600', marginBottom: '1rem', textTransform: 'capitalize' }}>
                {modalCard.category}
              </span>

              {/* For Person */}
              <div style={{ marginBottom: '1rem', padding: '1rem', background: '#f9f9f9', borderLeft: '4px solid #1976d2', borderRadius: '4px' }}>
                <p style={{ margin: '0.3rem 0', fontSize: '18px', color: '#666', fontWeight: 'bold' }}>
                   {modalCard.nameoftheperson}
                </p>
              </div>

              {/* Message */}
              <div style={{ marginBottom: '1rem' }}>
                <h3 style={{ fontSize: '1rem', color: '#333', marginBottom: '0.5rem' }}>Message</h3>
                <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
                  {modalCard.message}
                </p>
              </div>

              {/* From Details */}
              <div style={{ marginBottom: '1.5rem', padding: '0.8rem 1rem', background: '#f0f7ff', borderLeft: '3px solid #1976d2', borderRadius: '4px' }}>
                <p style={{ margin: 0, fontSize: '16px', color: '#666', fontWeight: 'bold' }}>
                  <strong>From:</strong> {modalCard.nameofthewisher}
                </p>
                {modalCard.website && (
                  <p style={{ margin: '6px 0 0 0', fontSize: '14px' }}>
                    <a href={modalCard.website} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
                      {modalCard.website}
                    </a>
                  </p>
                )}
                {socialLinks.length > 0 && (
                  <div style={{ marginTop: '10px' }}>
                    <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#555', fontWeight: 600 }}>Social:</p>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {socialLinks.map((link) => (
                        <a
                          key={`${modalCard.gid || modalCard.title}-${link.label}`}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: 'none',
                            color: '#1976d2',
                            fontSize: '13px',
                            padding: '4px 8px',
                            border: '1px solid #bcd7f4',
                            borderRadius: '12px',
                            background: '#ffffff',
                          }}
                        >
                          {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Date Posted */}
              <p style={{ fontSize: '0.85rem', color: '#999', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
                Posted: {modalCard.dateposted}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GreetingAndWishes;
